export const isAuthenticatedHandle = () => {
  const isAuthenticated = localStorage.getItem("isAuthenticated")
    ? JSON.parse(localStorage.getItem("isAuthenticated")!!)
    : false;
  return isAuthenticated;
};

export const pickRandomLayout = () => {
  const layouts = [
    [
      [8, 3, 9],
      [2, 1, 5],
      [4, 7, 6],
    ],
    [
      [4, 1, 2],
      [7, 3, 9],
      [8, 5, 6],
    ],
    [
      [1, 6, 2],
      [7, 4, 3],
      [5, 9, 8],
    ],
    [
      [4, 1, 2],
      [7, 9, 3],
      [6, 8, 5],
    ],
    [
      [1, 9, 2],
      [7, 5, 3],
      [8, 4, 6],
    ],
    [
      [2, 3, 5],
      [1, 4, 6],
      [9, 7, 8],
    ],
    [
      [1, 5, 2],
      [7, 4, 3],
      [8, 9, 6],
    ],
    [
      [4, 1, 2],
      [7, 5, 3],
      [8, 9, 6],
    ],
    [
      [2, 5, 3],
      [1, 6, 9],
      [4, 7, 8],
    ],
    [
      [4, 1, 2],
      [7, 6, 3],
      [9, 5, 8],
    ],
    [
      [5, 9, 2],
      [4, 1, 3],
      [7, 6, 8],
    ],
    [
      [1, 3, 5],
      [7, 2, 6],
      [8, 4, 9],
    ],
  ];

  const randomIndex = Math.floor(Math.random() * layouts.length);
  return layouts[randomIndex];
};
